import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CarrierLogoService {
  readonly flightLogoPlaceholder = 'assets/img/flights/flight-placeholder.png';

  getCarrierLogo(carrier: any): string {
    return carrier?.logo || this.flightLogoPlaceholder;
  }

  setLogoPlaceholder(event: Event): void {
    const image = event.target as HTMLImageElement | null;

    if (!image) {
      return;
    }

    if (image.src.includes(this.flightLogoPlaceholder)) {
      image.removeAttribute('src');
      return;
    }

    image.src = this.flightLogoPlaceholder;
  }
}
